import { patchPaymentMethodModification } from '@nemuru-eng/js-api-client';
import { useCallback, useState } from 'react';

import { useRequest } from '@/hooks/requests/useRequest';

type RequestParams = Parameters<typeof patchPaymentMethodModification>[0];
type Response = Awaited<ReturnType<typeof patchPaymentMethodModification>>;

export const usePatchPaymentMethodModification = () => {
  const { request, loading } = useRequest();
  const [error, setError] = useState<Error | undefined>(undefined);

  const submit = useCallback(
    async (params: RequestParams): Promise<Response> => {
      setError(undefined);

      try {
        return await request(patchPaymentMethodModification, params);
      } catch (err) {
        const applyError = err as Error;
        setError(applyError);
        throw applyError;
      }
    },
    [request],
  );

  const reset = useCallback(() => {
    setError(undefined);
  }, []);

  return {
    loading,
    error,
    submit,
    reset,
  };
};
